module.exports = __webpack_public_path__ + "static/media/logo_header_colour.8e2b1da3.svg";